const supervisedTypes = Object.freeze({
  Practitioner: 1,
  Intern: 2,
  Specialist: 99,
});

export default supervisedTypes;
